// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"6b5c579d","423":"79e1eb8a","589":"9d2c420a","739":"a57911f5"}[chunkId] + ".chunk.js";
};